import script from "./TokenInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./TokenInfo.vue?vue&type=script&setup=true&lang=js"

import "./TokenInfo.vue?vue&type=style&index=0&id=3013ce58&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3013ce58"]])

export default __exports__